if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty) {

		let alert = null;
		this.form.classList.add('processing');

		if (this.querySelector('.alert')) {
			this.querySelector('.alert').remove();
		}

		const body = JSON.stringify({
			line: parseInt(item.dataset.line),
			quantity: newQty
		});

		fetch(KROWN.settings.routes.cart_change_url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
			body
		})
			.then(response => response.json())
			.then(response => {
			if (response.status == 422) {
				alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.innerHTML = typeof response.description === 'string'
				? response.description
				: response.message;
			}

			return fetch('?section_id=helper-cart');
			})
			.then(response => response.text())
			.then(text => {
			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			});

			if (alert !== null) this.form.prepend(alert);
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

			document.dispatchEvent(new Event('cart-updated'));

			// === FREE SAMPLE / THRESHOLD LOGIC ===
			const totalWrapper = document.getElementById('free-sample-cart');
			const totalPriceElement = document.getElementById('get-total-price');
			const messageBox = document.getElementById('free-sample-message');
			const priceElement = document.getElementById('free-sample-price');

			if (totalWrapper && totalPriceElement) {
				const rawPrice = parseInt(totalPriceElement.getAttribute('get-total-price'));
				const threshold = parseInt(totalWrapper.getAttribute('data-threshold'));
				totalWrapper.setAttribute('data-cart-price', rawPrice);

				const sampleProducts = document.querySelectorAll('.sample-product');
				sampleProducts.forEach(product => {
				const button = product.querySelector('.sample-add-btn');
				product.classList.remove('locked', 'unlocked');

				if (rawPrice >= threshold) {
					product.classList.add('unlocked');
					if (button) button.disabled = false;
				} else {
					product.classList.add('locked');
					if (button) button.disabled = true;
				}
				});

				if (messageBox && priceElement) {
					const remaining = threshold - rawPrice;
					if (remaining > 0) {
						const formattedRemaining = (remaining / 100).toLocaleString('nl-NL', {
						style: 'currency',
						currency: 'EUR'
						});
						priceElement.textContent = formattedRemaining;
						messageBox.style.display = 'block';
					} else {
						messageBox.style.display = 'none';
					}
				}

				// === AUTO REMOVE (Ultra Fast Version) ===
				const REMOVE_VARIANT_IDS = [
				56079219097935, 56079309898063, 56079323496783, 55814294962511,
				56079216410959, 56079218508111, 55305752445263, 55305752478031,
				55305752510799, 55210538172751, 55210538205519, 55210538238287,
				57312118964559, 57832054391119, 57832054096207
				];
				const MIN_TOTAL = 6500;

				if (rawPrice < MIN_TOTAL) {
				console.log('💰 Below €60 — instant removing samples');

				// 1️⃣ CLEAR LOCAL DATA
				localStorage.setItem('selectedSampleIds', '[]');
				window.selectedSampleIds = [];

				// 2️⃣ COLLECT KEYS BEFORE REMOVING FROM DOM (IMPORTANT!)
				const updates = {};
				const itemsToRemove = [];

				document.querySelectorAll("[data-js-cart-item]").forEach(item => {
					const variantId = parseInt(item.getAttribute("data-variant-id"));
					if (REMOVE_VARIANT_IDS.includes(variantId)) {
					const key = item.getAttribute("data-id");
					if (key) {
						updates[key] = 0;     // for Shopify
						itemsToRemove.push(item); // for DOM removal
					}
					}
				});

				// If nothing to remove → stop
				if (!Object.keys(updates).length) {
					return;
				}

				// 3️⃣ INSTANT UI REMOVAL (now safe)
				itemsToRemove.forEach(item => {
					item.style.transition = "opacity 0.2s ease";
					item.style.opacity = "0";
					setTimeout(() => item.remove(), 200);
				});

				// 4️⃣ UPDATE HEADER COUNT immediately
				const headerCount = document.querySelectorAll("[data-header-cart-count]");
				headerCount.forEach(el => {
					el.textContent = Math.max(0, headerCount.length - itemsToRemove.length);
				});

				document.dispatchEvent(new Event("cart-updating"));

				// 5️⃣ FAST SHOPIFY REMOVE REQUEST
				fetch("/cart/update.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ updates })
				})
				.then(() => {
					console.log("✅ Shopify sync done (fast)");
					document.dispatchEvent(new Event("cart-updated"));
				})
				.catch(console.error);
				}

			}
			})
			.catch(e => {
			console.log(e);
			let alert = document.createElement('span');
			alert.classList.add('alert', 'alert--error');
			alert.textContent = KROWN.settings.locales.cart_general_error;
			this.form.prepend(alert);
			})
			.finally(() => {
			this.form.classList.remove('processing');
			});
		}


	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}